/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inner_Cta_CallInputs */

const en_inner_cta_call = /** @type {(inputs: Inner_Cta_CallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Book a discovery call`)
};

const lv_inner_cta_call = /** @type {(inputs: Inner_Cta_CallInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pieteikt iepazīšanās sarunu`)
};

/**
* | output |
* | --- |
* | "Book a discovery call" |
*
* @param {Inner_Cta_CallInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const inner_cta_call = /** @type {((inputs?: Inner_Cta_CallInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inner_Cta_CallInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_inner_cta_call(inputs)
	return en_inner_cta_call(inputs)
});